"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _eventhub = _interopRequireDefault(require("../lib/eventhub"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  data: function data() {
    return {
      activeError: null
    };
  },
  computed: {
    isErrorActive: function isErrorActive() {
      return !!this.activeError;
    }
  },
  beforeMount: function beforeMount() {
    // Listeners
    _eventhub["default"].on("core:errors:vue_".concat(this._uid, ":handle"), this.handleError);

    _eventhub["default"].on("core:errors:vue_".concat(this._uid, ":clear"), this.clearError);
  },
  beforeDestroy: function beforeDestroy() {
    // Remove listeners
    _eventhub["default"].off("core:errors:vue_".concat(this._uid, ":handle"), this.handleError);

    _eventhub["default"].off("core:errors:vue_".concat(this._uid, ":clear"), this.clearError);
  },
  methods: {
    clearError: function clearError() {
      this.$set(this, 'activeError', null);
    },
    handleError: function handleError(error) {
      this.$set(this, 'activeError', error);
    }
  }
};
exports["default"] = _default;